import React from 'react';
import Navigation from '../../../components/Navigation/Navigation';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';
import TraderCard from '../../../components/TraderCard/TraderCard';
import Footer from '../../../components/Footer/Footer';

const TraderPage = () => {
    return (
        <div>
            <Navigation />
            <BreadCrumb />
            <TraderCard />
            <Footer />
        </div>
    );
};

export default TraderPage;